// src/views/configuracion/areas/Areas.js
import React, { Fragment, useEffect, useState, useMemo } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarAreasConfiguracion } from '../../../actions/configuracion';
import NuevaArea from './NuevaArea';
import EliminarArea from './EliminarArea';
import EditarArea from './EditarArea';


const Areas = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Áreas',
            path: '/configuracion/areas'
        }
    ];

    const dispatch = useDispatch();

    const { listado } = useSelector(state => state.configuracion.areas);

    const [areas, setAreas] = useState([]);
    const [filterText, setFilterText] = useState('');

    const [areaAgregar, setAreaAgregar] = useState(null);
    const [areaEditar, setAreaEditar] = useState(null);     // para después
    const [areaEliminar, setAreaEliminar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.nombre,
            wrap: true
        },
        {
            name: 'Organizadores asignados',
            selector: row => row.organizadores,
            wrap: true,
            grow: 0.5
        },
        {
            name: '',
            cell: row => {
                return (
                    <div className="text-right w-100">
                        <button
                            type="button"
                            className="btn btn-sm btn-link px-2 float-end"
                            onClick={() => handleEliminarArea(row)}
                            disabled={!row._id}
                        >
                            <i className="fas fa-trash text-danger"></i>
                        </button>
                        <button
                            type="button"
                            className="btn btn-sm btn-link px-2 float-end"
                            onClick={() => handleEditarArea(row)}
                            disabled={!row._id}
                        >
                            <i className="fas fa-edit text-warning"></i>
                        </button>
                        <Link
                            className="btn btn-sm btn-link px-2 float-end"
                            to={`/configuracion/areas/organizadores/${row._id}`}
                        >
                            <i className="fas fa-list text-info"></i>
                        </Link>
                    </div>
                );
            }
        }
    ];

    /* Crear área */
    const handleAgregarArea = (area) => {
        setAreaEditar(null);
        setAreaEliminar(null);
        setAreaAgregar(area);     // {} para abrir, null para cerrar
    };

    /* Editar área */
    const handleEditarArea = (area) => {
        setAreaAgregar(null);
        setAreaEliminar(null);
        setAreaEditar(area);
    };

    /* Eliminar área */
    const handleEliminarArea = (area) => {
        setAreaAgregar(null);
        setAreaEditar(null);
        setAreaEliminar(area);   // el modal se abre cuando esto no es null
    };

    useEffect(() => {
        dispatch(buscarAreasConfiguracion());
    }, [dispatch]);

    useEffect(() => {
        setAreas(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [dispatch, rutasBread]);

    const filteredAreas = areas.filter(
        area =>
            (area.nombre || '').toLowerCase().includes(filterText.toLowerCase())
    );

    const subHeaderComponent = useMemo(() => {
        return (
            <div className="d-flex w-100 justify-content-between">
                <div className="col-md-4">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Buscar por nombre..."
                        value={filterText}
                        onChange={e => setFilterText(e.target.value)}
                    />
                </div>

                <div className="d-flex justify-content-end">
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => handleAgregarArea({})}
                    >
                        Agregar área
                    </button>
                </div>
            </div>
        );
    }, [filterText]);

    return (
        <Fragment>

            <NuevaArea area={areaAgregar} reestablecerArea={handleAgregarArea} />
            <EditarArea  area={areaEditar}    reestablecerArea={handleEditarArea} />
            <EliminarArea area={areaEliminar} reestablecerArea={handleEliminarArea} />
            {/** EditarArea lo conectamos en el siguiente paso */}

            <div className="row">
                <div className="col-md-12 px-4 pb-4">
                    <h3 className="mb-3 mt-5">Áreas</h3>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={filteredAreas}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                            subHeader
                            subHeaderComponent={subHeaderComponent}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Areas;
